import { createContext, useContext, ReactNode } from 'react';
import { TextAssetResponse } from '@goldcast/api/content';

const SharedPostContext = createContext<TextAssetResponse | null>(null);

export const SharedPostProvider = ({ children, post }: { children: ReactNode; post: TextAssetResponse | null }) => {
  return <SharedPostContext.Provider value={post}>{children}</SharedPostContext.Provider>;
};

export const useSharedPost = (): TextAssetResponse | null => {
  return useContext(SharedPostContext);
};
